import { useLookupFondChartsQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

import './FondsCharts.scss'
import type { FondChart } from "../../types/Fond";

const usersColors=[
      "#a44e6f",
      "#7bb743",
      "#a25aca",
      "#61be84",
      "#ca49a1",
      "#407e44",
      "#6369c7",
      "#d09d3b",
      "#668fcc",
      "#cb542f",
      "#40bec1",
      "#d94568",
      "#89833b",
      "#ce8ac8",
      "#c97c5f"
];


function FondBarCharts() {
  const { data, error, isLoading } = useLookupFondChartsQuery({r:{perso:0}});
  const {translate}=useTrads();
  console.log(data);
  const users:Record<string,number>={}
  const chartdata:Record<string,number|string>[]=[];
  data?.data.forEach((e:FondChart)=>{
    const em:Record<string,number|string>={
        "name":e.name,
        disponible:e.solde,
    }
    if(e.solde){
        e.sorties.forEach((userval)=>{
            em[userval.benef]=-1 * userval.montant
            users[userval.benef]=0;
        })
        chartdata.push(em);
    }
  })
  return (
    error ? (
        <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

    ) : isLoading ? (
        <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> 
    ) : data ? (
    
      <div>
        <h3>Fonds</h3>
        <div className="chart-grid">
            <BarChart width={550} height={500}
                
                //layout="vertical"
                data={chartdata}
                margin={{
                    top: 20,
                    right: 0,
                    left: 60,
                    bottom: 5,
                }}
                >
                <CartesianGrid   />
                <XAxis dataKey="name" />
                <YAxis width="auto"  />
                <Tooltip />
                <Legend />

                {Object.keys(users).map((e,index)=>(
                    <Bar key={e} dataKey={e} stackId="a" fill={usersColors[index]}  />
                ))}
                <Bar dataKey="disponible" stackId="a" fill="#82ca9d"  />                

                
                
                
                
            </BarChart>  
        </div>
      </div>
    
    ):null
  );

}
export default FondBarCharts;